/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowAUpLeftIcon24Regular = forwardRef('ArrowAUpLeftIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M16.5 3.125a.875.875 0 0 1 0 1.75H6.112L20.12 18.881a.875.875 0 1 1-1.238 1.238L4.875 6.112V16.5a.875.875 0 0 1-1.75 0V6A2.875 2.875 0 0 1 6 3.125h10.5Z" })));
});
